import React from 'react';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

export default CreateReactClass({
    displayName: 'dropdown-menu',

    propTypes: {
        id: PropTypes.string,
        defaultOption: PropTypes.string,
        selectedOptionValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        onChange: PropTypes.func,
        label: PropTypes.string,
        optionList: PropTypes.object,
        elementValueFunction: PropTypes.func,
        elementDisplayFunction: PropTypes.func,
        classesDivWrapper: PropTypes.string,
        classesLabel: PropTypes.string,
        classesSelect: PropTypes.string,
    },

    createDropdownItems: function(optionList) {
        let options = [];
        let defaultInList = false;

        if (optionList) {
            optionList.map((o) => {
                const value = this.props.elementValueFunction(o);
                const displayValue = this.props.elementDisplayFunction(o);
                defaultInList = defaultInList || displayValue === this.props.defaultOption;

                options.push(
                    <option key={value} value={value} disabled={o.get('disabled')}>
                        {displayValue}
                    </option>
                );
            });

            if (this.props.defaultOption && !defaultInList) {
                options.unshift(
                    <option value="default" style={{ display: 'none' }} key={this.props.defaultOption}>
                        {this.props.defaultOption}
                    </option>
                );
            }
        }

        return options;
    },

    render() {
        const handleChange = (event) => {
            if (this.props.optionList.find((item) => event.target.value == this.props.elementValueFunction(item))) {
                this.props.onChange(event.target.value);
            } else {
                console.error(
                    'INPUT VALIDATION ERROR - Dropdown value was not found within list of expected values, suppressing selection.'
                );
            }
        };

        let options = this.createDropdownItems(this.props.optionList);
        let label = this.props.label;
        const groupID = this.props.id && this.props.id.length > 0 ? `form-group-${this.props.id}` : '';
        const selectedValue = this.props.selectedOptionValue ? this.props.selectedOptionValue : 'default';
        const disabledSetting = options.length === 0 || (this.props.optionList && this.props.optionList.size == 0);

        return (
            <div key={`form-group-${this.props.id}`} id={groupID} className={this.props.classesDivWrapper}>
                <label key="control-label" className={this.props.classesLabel}>
                    {label}
                </label>

                <select
                    value={selectedValue}
                    onChange={handleChange}
                    disabled={disabledSetting}
                    placeholder={this.props.defaultOption}
                    id={this.props.id}
                    key={this.props.id}
                    className={this.props.classesSelect}
                >
                    {options}
                </select>
            </div>
        );
    },
});
